import { isObject } from 'lodash/fp';

export default (value, emptyValue) => {
  if (value === null || value === undefined) {
    return emptyValue;
  }

  if (isObject(value)) {
    if (value.min === undefined) {
      value = { ...value, min: emptyValue.min };
    }

    if (value.max === undefined) {
      value = { ...value, max: emptyValue.max };
    }
  }

  return value;
};
